import type { LegalPageContent } from '@/types/pageContent';

export const DEFAULT_PRIVACY: LegalPageContent = {
    lastUpdated: '2025-12-01',
    sections: [
        {
            heading: 'Data Controller',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'Stork Rentals S.L. is the data controller for your personal information:',
                },
                {
                    title: 'Company',
                    body: 'Stork Rentals S.L.',
                },
                {
                    title: 'Address',
                    body: 'Barcelona, Spain',
                },
                {
                    title: 'Email',
                    body: 'info@thestorkexchange.ie',
                },
            ],
        },
        {
            heading: 'Information We Collect',
            style: 'list',
            items: [
                {
                    title: 'Information You Provide',
                    body: 'Name, email address, phone number',
                },
                {
                    title: 'Information You Provide',
                    body: 'Accommodation/delivery address',
                },
                {
                    title: 'Information You Provide',
                    body: 'Payment information (processed by Stripe)',
                },
                {
                    title: 'Information You Provide',
                    body: 'Rental preferences and order history',
                },
                {
                    title: 'Information You Provide',
                    body: 'Customer service communications',
                },
                {
                    title: 'Automatically Collected',
                    body: 'Device information and browser type',
                },
                {
                    title: 'Automatically Collected',
                    body: 'IP address and approximate location',
                },
                {
                    title: 'Automatically Collected',
                    body: 'Pages visited and time spent on site',
                },
                {
                    title: 'Automatically Collected',
                    body: 'Referral source',
                },
            ],
        },
        {
            heading: 'How We Use Your Information',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'We use your information to:',
                },
                {
                    title: 'Process Rentals',
                    body: 'Create reservations, process payments, send confirmations and reminders',
                },
                {
                    title: 'Customer Service',
                    body: 'Respond to inquiries, handle complaints, provide support',
                },
                {
                    title: 'Improve Services',
                    body: 'Analyze usage patterns, develop new features, enhance user experience',
                },
                {
                    title: 'Marketing',
                    body: 'Send promotional emails (with your consent), notify about special offers',
                },
                {
                    title: 'Legal Compliance',
                    body: 'Meet tax and accounting requirements, respond to legal requests',
                },
            ],
        },
        {
            heading: 'Legal Basis (GDPR)',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'Under GDPR, we process your data based on:',
                },
                {
                    title: 'Contract',
                    body: 'Processing necessary to fulfill rental agreements',
                },
                {
                    title: 'Consent',
                    body: 'Marketing communications (you can withdraw anytime)',
                },
                {
                    title: 'Legitimate Interest',
                    body: 'Improving services, fraud prevention',
                },
                {
                    title: 'Legal Obligation',
                    body: 'Tax records, legal compliance',
                },
            ],
        },
        {
            heading: 'Data Sharing',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'We share data with trusted partners only as necessary:',
                },
                {
                    title: 'Payment Processors',
                    body: 'Stripe processes all payments securely. We never store full card details.',
                },
                {
                    title: 'Email Service',
                    body: 'For transactional and marketing communications',
                },
                {
                    title: 'Analytics',
                    body: 'Anonymous usage data to improve our service',
                },
                {
                    title: 'Legal Requirements',
                    body: 'When required by law or to protect rights',
                },
                {
                    title: '',
                    body: 'We do not sell your personal information to third parties.',
                },
            ],
        },
        {
            heading: 'Your Rights (GDPR)',
            style: 'cards',
            items: [
                {
                    title: 'Right to Access',
                    body: 'Request a copy of your personal data',
                },
                {
                    title: 'Right to Rectification',
                    body: 'Correct inaccurate information',
                },
                {
                    title: 'Right to Erasure',
                    body: 'Request deletion of your data',
                },
                {
                    title: 'Right to Portability',
                    body: 'Receive data in portable format',
                },
                {
                    title: 'Right to Object',
                    body: 'Object to processing for marketing',
                },
                {
                    title: 'Withdraw Consent',
                    body: 'Withdraw consent at any time',
                },
                {
                    title: 'Exercise Your Rights',
                    body: 'To exercise these rights, email us at info@thestorkexchange.ie',
                },
            ],
        },
        {
            heading: 'Data Retention',
            style: 'list',
            items: [
                {
                    title: '',
                    body: 'We retain your data only as long as necessary:',
                },
                {
                    title: 'Account data',
                    body: 'Until you delete your account',
                },
                {
                    title: 'Rental records',
                    body: '7 years (tax/legal requirements)',
                },
                {
                    title: 'Marketing consent',
                    body: 'Until you unsubscribe',
                },
                {
                    title: 'Analytics data',
                    body: '26 months (anonymized)',
                },
            ],
        },
        {
            heading: 'Cookies',
            style: 'list',
            items: [
                {
                    title: '',
                    body: 'We use cookies to:',
                },
                {
                    title: 'Essential',
                    body: 'Remember your cart, session, preferences',
                },
                {
                    title: 'Analytics',
                    body: 'Understand how visitors use our site',
                },
                {
                    title: 'Marketing',
                    body: 'Show relevant ads (with consent)',
                },
                {
                    title: '',
                    body: 'You can manage cookie preferences in your browser settings.',
                },
            ],
        },
        {
            heading: 'Security',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'We implement appropriate technical and organizational measures to protect your data, including encryption, access controls, and regular security audits. While we strive to protect your information, no transmission over the internet is 100% secure.',
                },
            ],
        },
        {
            heading: 'Contact Us',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'For privacy-related inquiries or to exercise your rights:',
                },
                {
                    title: 'Email',
                    body: 'info@thestorkexchange.ie',
                },
                {
                    title: 'General Support',
                    body: 'info@thestorkexchange.ie',
                },
                {
                    title: '',
                    body: 'You also have the right to lodge a complaint with your local data protection authority (in Spain: AEPD - Agencia Española de Protección de Datos).',
                },
            ],
        },
        {
            heading: 'Policy Updates',
            style: 'default',
            items: [
                {
                    title: '',
                    body: 'We may update this Privacy Policy from time to time. We will notify you of significant changes via email or prominent notice on our website. Continued use of our services after changes constitutes acceptance of the updated policy.',
                },
            ],
        },
    ],
};
